import { Observable } from 'rxjs';
import { BrandResources } from '../brand-resources.model';

export abstract class BrandGateway {
  abstract getBrandResources(brand: string): Observable<BrandResources>;
  abstract getSelectedBrandResources(): Observable<BrandResources>;
  abstract getBrandTitle(): Observable<string | null>;
}
